import { render, staticRenderFns } from "./SkeletonTableLoader.vue?vue&type=template&id=d68482e2&scoped=true"
import script from "./SkeletonTableLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonTableLoader.vue?vue&type=script&lang=js"
import style0 from "./SkeletonTableLoader.vue?vue&type=style&index=0&id=d68482e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68482e2",
  null
  
)

export default component.exports